import { Component, Vue } from "vue-property-decorator";
import { SEPSIS_ORDER } from "./ListSepsis";

@Component({})
export default class HeaderSepsis extends Vue {
  get alertOrder() {
    return SEPSIS_ORDER;
  }
}
